import { render, staticRenderFns } from "./pedidos-item-add.vue?vue&type=template&id=31e7dddc"
import script from "./pedidos-item-add.vue?vue&type=script&lang=js"
export * from "./pedidos-item-add.vue?vue&type=script&lang=js"
import style0 from "./pedidos-item-add.vue?vue&type=style&index=0&id=31e7dddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports